import { useAddressConfig } from "./useAddressConfig";
import { useCompanyInformationConfig } from "./useCompanyInformationConfig";
import { useCustomFieldsConfig } from "./useCustomFieldsConfig";
import { useEmploymentTypeConfig } from "./useEmploymentTypeConfig";
import { useExpectedHoursConfig } from "./useExpectedHoursConfig";
import { useHiringInformationConfig } from "./useHiringInformationConfig";
import { useJobInformationConfig } from "./useJobInformationConfig"
import { useKeyDatesConfig } from "./useKeyDatesConfig";
import { useOrganizationConfig } from "./useOrganizationConfig";
import { usePersonalInformationConfig } from "./usePersonalInformationConfig";
import { useStatusConfig } from "./useStatusConfig";
import { useTerminateConfig } from "./useTerminateConfig";

export const useConfig = (option) => {
    const jobInformation = useJobInformationConfig();
    const address = useAddressConfig();
    const companyInformation = useCompanyInformationConfig();
    const employmentType = useEmploymentTypeConfig();
    const expectedHours = useExpectedHoursConfig();
    const hiringInformation = useHiringInformationConfig();
    const keyDates = useKeyDatesConfig();
    const organization = useOrganizationConfig();
    const personalInformation = usePersonalInformationConfig();
    const status = useStatusConfig();
    const terminate = useTerminateConfig();
    const customFields = useCustomFieldsConfig();

    const configs = {
        jobInformation,
        address,
        companyInformation,
        employmentType,
        expectedHours,
        hiringInformation,
        customFields,
        keyDates,
        organization,
        personalInformation,
        status,
        terminate,
    };

    return option ? configs[option] : configs;
}